<template>
  <div class="invitelist">
    <div v-if="user" class="invitelist-list">
      <div class="invitelist-item flex-row" v-for="(item,index) in user.rec_user" :key="index">
        <div class="invitelist-left flex-row">
          <div class="invitelist-icon">
            <img v-if="item.avatar" class="invitelist-icon-img" :src="item.avatar" alt />
            <img v-else class="invitelist-icon-img" src="../../static/images/icon_default.png" alt />
          </div>
          <div class="invitelist-name">{{item.nickname}}</div>
        </div>
        <div class="invitelist-right">{{item.created}}</div>
      </div>
    </div>
    <div v-if="!user ||  (user && user.rec_user.length<=0)" class="nomore text-center">暂无记录</div>
  </div>
</template>

<script>
export default {
  name: "invitelist",
  urlData: {},
  data() {
    return {
      user: null,
    };
  },
  methods: {
    //获取用户信息
    getUser() {
      var t = this;
      var params = {
        activity_id: t._getAPPParams().activity_id
      };
      console.log(params);
      t._get("user", "User.getUser", params)
        .then(res => {
          if (res.status == 0) {
            t.user = res.data;
          }else{
            t.$toast(res.msg)
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },
  },
  components: {},
  created() {
    var t = this;
    console.log(t.version);
    t.urlData = this.$route.query;
    console.log("t.urlData");
    console.log(t.urlData);
    t.getUser();
  }
};
</script>
<style scoped lang="scss" src="../../static/scss/invitelist.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->